import { __assign, __read, __rest, __spread } from "tslib";
import { convertDate } from '@keen.io/time-utils';
import { KEEN_KEY } from '../../constants';
import { mergePropertiesGroup, fillWithEmptyKeys } from '../../utils';
export var defaultTransformation = function (result, parserSettings) {
    var data = [];
    var keys = new Set();
    var mergePropertiesOrder = parserSettings.mergePropertiesOrder, fillEmptyIntervalsKeys = parserSettings.fillEmptyIntervalsKeys, dateModifier = parserSettings.dateModifier;
    result.forEach(function (interval) {
        var _a;
        var _b = interval, timeframe = _b.timeframe, value = _b.value;
        var intervalData = {};
        var intervalKeys = new Set();
        value
            .map(function (groupedProperties) {
            return mergePropertiesGroup(groupedProperties, mergePropertiesOrder);
        })
            .forEach(function (_a) {
            var result = _a.result, properties = __rest(_a, ["result"]);
            Object.values(properties).forEach(function (name) {
                intervalKeys.add(name);
                intervalData[name] = result;
            });
        });
        data.push(__assign((_a = {}, _a[KEEN_KEY] = convertDate(timeframe.start, dateModifier), _a), intervalData));
        intervalKeys.forEach(function (key) { return keys.add("" + key); });
    });
    if (fillEmptyIntervalsKeys) {
        data = fillWithEmptyKeys(__spread(keys), data, 0);
    }
    return {
        data: data,
        keys: __spread(keys),
    };
};
